import KycFail from './applications/renewal/pages/KycFail/KycFail';
import SuccessKit from "./_shared/welcome-kit";

import {
  RenewalFailed,
  RenewalLogin,
  RenewalPayment,
  RenewalSuccess,
  RenewalSummary,
  RenewalVehicleDriverInfo,
  RenewalWrapperApplication,
} from "./applications/renewal";
import {
  TravelCalculate,
  TravelPayment,
  TravelInformation,
  TravelSuccess,
  TravelWrapperApplication,
  TravelFailed,
  TravelSummary,
} from "./applications/travel";
const routes = [
  {
    name: "renewal",
    key: "renewal",
    route: "/renewal",
    component: <RenewalWrapperApplication component={RenewalLogin} />,
  },
  {
    name: "renewal-vehicle-driver-info",
    key: "renewal-vehicle-driver-info",
    route: "/renewal/vehicle-driver-info",
    component: (
      <RenewalWrapperApplication component={RenewalVehicleDriverInfo} />
    ),
  },
  {
    name: "renewal-success",
    key: "renewal-success",
    route: "/renewal/success",
    component: <RenewalSuccess />,
  },
  {
    name: "SuccessKit",
    idx: "SuccessKit",
    route: "/renewal/kit/:type",
    component: <SuccessKit />,
  },
  {
    name: "renewal-failed",
    key: "renewal-failed",
    route: "/renewal/failed",
    component: <RenewalFailed />,
  },
  {
    name: "renewal-failed",
    idx: "medmal-failed",
    route: "/renewal/KycFail",
    component: <KycFail />,
  },

  {
    name: "renewal-summary",
    key: "renewal-summary",
    route: "/renewal/summary",
    component: <RenewalSummary />,
  },
  {
    name: "renewal-payment",
    key: "renewal-payment",
    route: "/renewal/payment",
    component: (
      <RenewalWrapperApplication
        component={RenewalPayment}
        nextText={"POLICY.PAY"}
      />
    ),
  },
  {
    name: "travel",
    key: "travel",
    route: "/travel",
    component: <TravelWrapperApplication component={TravelCalculate} />,
  },
  {
    name: "travel-details",
    key: "travel-details",
    route: "/travel/details",
    component: <TravelWrapperApplication component={TravelInformation} />,
  },
  {
    name: "travel-payment",
    key: "travel-payment",
    route: "/travel/payment",
    component: (
      <TravelWrapperApplication component={TravelPayment} showFooter={true} />
    ),
  },
  {
    name: "travel-success",
    key: "travel-success",
    route: "/travel/success",
    component: <TravelWrapperApplication component={TravelSuccess} />,
  },
  {
    name: "travel-failed",
    key: "travel-failed",
    route: "/travel/failed",
    component: <TravelWrapperApplication component={TravelFailed} />,
  },
  {
    name: "travel-summary",
    key: "travel-summary",
    route: "/travel/summary",
    component: <TravelWrapperApplication component={TravelSummary} />,
  },

  // business line routes started for travel

  {
    name: "travel",
    key: "travel",
    route: "/:businessLine/travel",
    component: <TravelWrapperApplication component={TravelCalculate} />,
  },
  {
    name: "travel-details",
    key: "travel-details",
    route: "/:businessLine/travel/details",
    component: <TravelWrapperApplication component={TravelInformation} />,
  },
  {
    name: "travel-payment",
    key: "travel-payment",
    route: "/:businessLine/travel/payment",
    component: (
      <TravelWrapperApplication component={TravelPayment} showFooter={true} />
    ),
  },
  {
    name: "travel-success",
    key: "travel-success",
    route: "/:businessLine/travel/success",
    component: <TravelWrapperApplication component={TravelSuccess} />,
  },
  {
    name: "travel-failed",
    key: "travel-failed",
    route: "/:businessLine/travel/failed",
    component: <TravelWrapperApplication component={TravelFailed} />,
  },
  {
    name: "travel-summary",
    key: "travel-summary",
    route: "/:businessLine/travel/summary",
    component: <TravelWrapperApplication component={TravelSummary} />,
  },
  // routes ended for trave (bussiness line)
];

export default routes;
